module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_8003.9888392a.png";